
import {Vue, Component, Prop} from 'vue-property-decorator';

@Component({})
export default class ImportHelpDialog extends Vue {

  @Prop()
  dialogVisible: boolean;
}
